var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageDecorTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 575 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.499 326.217C308.882 326.217 326.216 308.883 326.216 287.5C326.216 266.118 308.882 248.784 287.499 248.784C266.117 248.784 248.783 266.118 248.783 287.5C248.783 308.883 266.117 326.217 287.499 326.217Z",
    stroke: "#FAE632",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.499 385.065C341.383 385.065 385.064 341.384 385.064 287.5C385.064 233.616 341.383 189.935 287.499 189.935C233.616 189.935 189.935 233.616 189.935 287.5C189.935 341.384 233.616 385.065 287.499 385.065Z",
    stroke: "#FAE632",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.501 450.108C377.307 450.108 450.109 377.306 450.109 287.5C450.109 197.694 377.307 124.892 287.501 124.892C197.695 124.892 124.893 197.694 124.893 287.5C124.893 377.306 197.695 450.108 287.501 450.108Z",
    stroke: "#FAE632",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.499 512.054C411.517 512.054 512.053 411.518 512.053 287.5C512.053 163.483 411.517 62.9463 287.499 62.9463C163.482 62.9463 62.9453 163.483 62.9453 287.5C62.9453 411.518 163.482 512.054 287.499 512.054Z",
    stroke: "#FAE632",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5 574C445.73 574 574 445.73 574 287.5C574 129.27 445.73 1 287.5 1C129.27 1 1 129.27 1 287.5C1 445.73 129.27 574 287.5 574Z",
    stroke: "#FAE632",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageDecorTop);
export default __webpack_public_path__ + "static/media/homepage-decor-top.2a0319263bcc18fa7242449566b84139.svg";
export { ForwardRef as ReactComponent };